import {
  SignInBody,
  SignInResponse,
  signIn,
} from '@reception-web/common/api/app'
import { AxiosError } from 'axios'
import useSWRMutation from 'swr/mutation'

export const useSignInApi = (args: SignInBody) => {
  const { data, trigger, error } = useSWRMutation<
    SignInResponse,
    AxiosError<Error>
  >(`/aos/sign-in`, () => signIn(args).then((res) => res.data))

  return {
    data,
    trigger,
    error,
  }
}
